export default "__VITE_ASSET__HToEluok__"